import React, { useLayoutEffect, useState, useRef, useEffect } from 'react';
import './about.scss';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

function BriefAbout() {
    useEffect(() => {
        gsap.registerPlugin(ScrollTrigger);

        const texts = gsap.utils.toArray(".text-glow")
        texts.forEach((text) => {

            gsap.to(text, {
                scrollTrigger: {
                    trigger: text,
                    toggleActions: "restart none resume reset",
                    start: "top 55%",
                    end: "bottom 60%",
                    // markers: true
                },
                autoAlpha: 0.96,
            })
        })
    }, [])

    return (
        <section id='about-section'>
            <div className='about-section-wrapper'>
                <p className='brief-about-text'>
                    <span className='text-glow glow-1'>
                        I'm a Full-Stack Web Developer focused on writing
                    </span>
                    <span className='text-glow glow-2'>
                        clean,elegant,<br/>and efficient code. I
                    </span>
                    <span className='text-glow glow-3'>
                        have always been
                    </span>
                    <span className='text-glow glow-4'>
                        excited about the
                    </span>
                    <span className='text-glow glow-5'>
                        entire development spectrum.
                    </span>
                    <br/>
                    <span className='text-glow glow-6'>
                        Right now, you can find me building projects, studying for
                    </span>
                    <span className='text-glow glow-7'>
                        tests ;), or hacking away DSA problems. 
                    </span>
                    <span className='text-glow glow-8'>
                        I'm also known to
                    </span>
                    <span className='text-glow glow-9'>
                        dabble in Solidity and Blender
                    </span>
                    <span className='text-glow glow-10'>
                        from time to time.
                    </span>
                </p>
            </div>
        </section>
    )   
}
export default BriefAbout;
